<template>
    <div class="mt-5 block max-w-full lg:hidden">
        <div
            ref="sliderElement"
            class="swiper swiper-our-advantages">
            <div class="swiper-wrapper items-stretch">
                <div
                    v-for="(item, index) in items"
                    :key="index"
                    class="swiper-slide !h-auto w-full max-w-[17.5rem]">
                    <OurAdvantagesCard
                        class="flex h-full flex-col justify-between">
                        <div>
                            <h2
                                v-html="item.title"
                                class="text-20/120 font-semibold" />
                            <div
                                v-html="item.description"
                                class="mt-3 w-full max-w-[20rem] text-16/148 text-accent-100" />
                        </div>
                        <div class="mt-3">
                            <Component :is="item.icon" />
                        </div>
                    </OurAdvantagesCard>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { Swiper } from 'swiper'

import OurAdvantagesCard from '~/components/pages/directions/our-advantages-section/OurAdvantagesCard.vue'
import type { IOurAdvantagesItem } from '~/components/pages/directions/our-advantages-section/our-advantages.types'

defineProps({
    items: {
        type: Array as PropType<IOurAdvantagesItem[]>,
        required: true,
    },
})

const sliderElement = ref<HTMLElement | null>(null)
let slider: Swiper | null = null

onMounted(() => {
    if (!sliderElement.value) return

    slider = new Swiper(sliderElement.value, {
        slidesPerView: 'auto',
        spaceBetween: 8,
        breakpoints: {
            375: {
                spaceBetween: 20,
            },
            744: {
                spaceBetween: 20,
            },
        },
    })
})

onBeforeUnmount(() => {
    slider?.destroy()
})
</script>
